import { DeviceType } from '../../shared/types/ast';

export const RESULT_LIST_SPACE_1 = 6;
export const RESULT_LIST_SPACE_2 = 12;
export const RESULT_LIST_SPACE_3 = 24;
export const RESULT_LIST_ALT_SPACE_3 = 18;
export const RESULT_LIST_SPACE_4 = 30;
export const RESULT_LIST_ALT_SPACE_4 = 24;
export const RESULT_LIST_SPACE_5 = 36;

export const bannerName = (deviceType: DeviceType, index: number) =>
    `${deviceType === 'mobile' ? 'board' : 'netboard'}_${index}`;
